export enum UserRoleSelector {
  SuperAdmin = "SuperAdmin",
  Admin = "Admin",
  Manager = "Manager",
  AfterSale = "After Sale",
  SalesAdvisor = "SalesAdvisor",
  CommercialSpecialist = "SalesAdvisor",
  Accounting = "Accounting",
  CommunityManager = "CommunityManager",
  CreditManager = "Credit Manager",
}
